<app-breadcrumbs></app-breadcrumbs>
<div>
  <div id="mist-table-wrapper">
    <div [cfaLoading]="isLoading">
      <mat-form-field id="filter-field">
        <input matInput [(ngModel)]="filterText" (keyup)="applyFilter($event.target.value)" placeholder="Filter">
      </mat-form-field>
      <div class="toggle-container">
        <mat-slide-toggle id="offline-toggle" [(ngModel)]="onlyShowOffline" (change)="onToggle()">
          Only show offline
        </mat-slide-toggle>
        <mat-slide-toggle id="all-offline-toggle" [(ngModel)]="hideAllAPsOffline" (change)="onToggle()">
          Hide all AP's offline
        </mat-slide-toggle>
        <mat-slide-toggle id="lab-toggle" [(ngModel)]="hideLabs" (change)="onToggle()">
          Hide labs
        </mat-slide-toggle>
        <mat-slide-toggle id="future-toggle" [(ngModel)]="hideFutures" (change)="onToggle()">
          Hide Futures
        </mat-slide-toggle>
        <mat-slide-toggle id="remodel-toggle" [(ngModel)]="hideRemodels" (change)="onToggle()">
          Hide Remodels
        </mat-slide-toggle>
      </div>
    </div>
    <table id="mist-table" #mistsTable mat-table matSort [dataSource]="dataSource" class="mat-elevation-z8" matSortActive="storeNumber" matSortDirection="asc">
      <ng-container matColumnDef="storeNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Store Number </th>
        <td mat-cell *matCellDef="let mistLocation"> {{mistLocation.location.number}} </td>
      </ng-container>
      <ng-container matColumnDef="locationName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Location Name </th>
        <td mat-cell *matCellDef="let mistLocation"> {{mistLocation.location.name}} </td>
      </ng-container>
      <ng-container matColumnDef="locationStatus">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Location Status </th>
        <td mat-cell *matCellDef="let mistLocation"> {{mistLocation.location.status}} </td>
      </ng-container>
      <ng-container matColumnDef="locationTimeZone">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Time Zone </th>
        <td mat-cell *matCellDef="let mistLocation"> {{mistLocation.location.timezone}} </td>
      </ng-container>
      <ng-container matColumnDef="mists">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Mists </th>
        <td mat-cell *matCellDef="let mistLocation">
          @for (mist of mistLocation.mists; track mist) {
            <span>
              @if (mist.connected==true) {
                <mat-icon
                  matTooltip="name: {{mist.name}}"
                  [matTooltipClass]="'my-tooltip'"
                  class="mist-connected-icon">check_circle_outline
                </mat-icon>
              }
              @if (mist.connected==false) {
                <mat-icon
                  matTooltip="name: {{mist.nane}}"
                  [matTooltipClass]="'my-tooltip'"
                  class="mist-disconnected-icon">highlight_off
                </mat-icon>
              }
            </span>
          }
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10, 20, 30, 50]" showFirstLastButtons></mat-paginator>
  </div>
</div>